<template>
    <MenuModal
        :is-visible="modalStore.activeModal === MODAL_HAMBURGER"
        class="hamburger-menu"
        @close="modalStore.closeModal"
    >
        <HamburgerMenuModalList
            location="main"
            :links="[
                { to: '/', text: 'Overview' },
                { to: '/account', text: 'Account & profile' },
                { to: '/favorites', text: 'Your favorites' },
                { to: '/uploads', text: 'Your video uploads', hideSponsor: true },
                { to: '/events', text: 'Events' }
            ]"
        >
            <template v-if="!authStore.isSponsor" #above>
                <li>
                    <BaseButton
                        :element="defineNuxtLink({})"
                        to="/upload/checklist"
                        icon-left="plus"
                    >
                        Upload video
                    </BaseButton>
                </li>
            </template>
        </HamburgerMenuModalList>
        <HamburgerMenuModalList
            location="secondary"
            :links="[
                { to: '/how-to-make-a-video', text: 'How to make a video', hideSponsor: true },
                { to: '/about-us', text: 'Contact MedPeers' },
                { to: '/faq', text: 'FAQ' },
            ]"
        >
            <template #below>
                <li>
                    <NuxtLink
                        to="https://tikkie.me/pay/IOSolutions/fjaSc1tiKJRyFfXhQd2Ses/10,50,100"
                        gtm-donate
                        external
                    >
                        Donate
                    </NuxtLink>
                </li>
            </template>
        </HamburgerMenuModalList>
        <hr>
        <HamburgerMenuModalList
            location="footer"
            :links="[
                { to: '/legal', text: 'Terms and conditions' },
                { to: '/legal/privacy', text: 'Privacy' },
                { to: '/legal/security', text: 'Security' }
            ]"
        />
    </MenuModal>
</template>

<script setup>
import { useModalStore, MODAL_HAMBURGER } from '~/store/modal';
import { useAuthStore } from '~/store/auth.js';

const modalStore = useModalStore();
const authStore = useAuthStore();

</script>

<style lang="less">
.hamburger-menu {
    hr {
        position: relative;
        background: var(--color-secondary);
        opacity: .2;
        height: 1px;
        border: none;
        margin-top: var(--spacing-md);
        margin-bottom: var(--spacing-md);
        margin-left: calc(var(--spacing-md) * -1);
        margin-right: calc(var(--spacing-md) * -1);
    }

    .router-link-exact-active {
        text-decoration: underline;
    }
}
</style>
